import * as React from 'react';
import { styled } from '@mui/material/styles';
import {
  Table, TableBody, TableCell, tableCellClasses, TableContainer,
  TableHead, TableRow, Paper, IconButton, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Button
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../../State/Store';
import { fetchDeals, deleteDeal, updateDeal } from '../../../State/admin/DealSlice';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function DealTable() {
  const dispatch = useAppDispatch();
  const { deal } = useAppSelector((store) => store);

  const [editDialogOpen, setEditDialogOpen] = React.useState(false);
  const [selectedDeal, setSelectedDeal] = React.useState<any>(null);
  const [title, setTitle] = React.useState('');
  const [discount, setDiscount] = React.useState<number>(0);

  React.useEffect(() => {
    dispatch(fetchDeals());
  }, [dispatch]);

  const handleDeleteDeal = (id: number) => {
    if (window.confirm("Are you sure you want to delete this deal?")) {
      dispatch(deleteDeal(id));
    }
  };

  const handleOpenEdit = (dealItem: any) => {
    setSelectedDeal(dealItem);
    setTitle(dealItem.title || '');
    setDiscount(dealItem.discount || 0);
    setEditDialogOpen(true);
  };

  const handleSaveUpdate = async () => {
    if (!selectedDeal) return;
    await dispatch(updateDeal({
      id: Number(selectedDeal.id),
      dealData: { title, discount: Number(discount) }
    }));
    setEditDialogOpen(false);
    dispatch(fetchDeals());
  };

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>No</StyledTableCell>
              <StyledTableCell>Image</StyledTableCell>
              <StyledTableCell>Title / Category</StyledTableCell>
              <StyledTableCell align="right">Discount (%)</StyledTableCell>
              <StyledTableCell align="right">Products Count</StyledTableCell>
              <StyledTableCell align="right">Update</StyledTableCell>
              <StyledTableCell align="right">Delete</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deal.deals?.map((item: any, index: number) => (
              <StyledTableRow key={item.id}>
                <StyledTableCell component="th" scope="row">
                  {index + 1}
                </StyledTableCell>
                <StyledTableCell>
                  <img
                    className="w-20 rounded-md h-14 object-cover"
                    src={
                      item.category?.image ||
                      item.products?.[0]?.images?.[0] ||
                      "https://via.placeholder.com/150"
                    }
                    alt={item.title || "Deal Image"}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  {item.title || item.category?.name || item.category?.categoryId || "N/A"}
                </StyledTableCell>
                <StyledTableCell align="right">{item.discount}%</StyledTableCell>
                <StyledTableCell align="right">
                  {item.products ? item.products.length : 0}
                </StyledTableCell>
                <StyledTableCell align="right">
                  <IconButton onClick={() => handleOpenEdit(item)} color="primary">
                    <Edit />
                  </IconButton>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <IconButton onClick={() => handleDeleteDeal(item.id)}>
                    <Delete sx={{ color: 'red' }} />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Edit Deal Modal */}
      <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>Update Deal</DialogTitle>
        <DialogContent className="space-y-4 pt-2">
          <TextField
            fullWidth
            label="Deal Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            margin="dense"
          />
          <TextField
            fullWidth
            type="number"
            label="Discount (%)"
            value={discount}
            onChange={(e) => setDiscount(Number(e.target.value))}
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleSaveUpdate} variant="contained" color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}